import api from "@/lib/api";

/** Creation session (CP-S-…) + privacy-safe device token (random, browser-bound, hashed server-side). Headers are added by the api interceptor. */
const DEVICE_KEY = "cpenz_device_token";
const SESSION_KEY = "cpenz_creation_session";
const CLIENT_KEY = "cpenz_client_session";

export function deviceToken() {
  try {
    let t = localStorage.getItem(DEVICE_KEY);
    if (!t) { t = Array.from(crypto.getRandomValues(new Uint8Array(24))).map((b) => b.toString(16).padStart(2, "0")).join(""); localStorage.setItem(DEVICE_KEY, t); }
    return t;
  } catch { return null; }
}

export function creationSession() {
  try { return sessionStorage.getItem(SESSION_KEY); } catch { return null; }
}

let opening = null;
export function ensureCreationSession() {
  if (creationSession() || opening) return opening || Promise.resolve(creationSession());
  let cs = sessionStorage.getItem(CLIENT_KEY);
  if (!cs) { cs = Math.random().toString(36).slice(2, 14); sessionStorage.setItem(CLIENT_KEY, cs); }
  opening = api.post("/provenance/session", { lang: navigator.language, tz: Intl.DateTimeFormat().resolvedOptions().timeZone, screen: `${window.screen?.width}x${window.screen?.height}`, client_session: cs })
    .then(({ data }) => { sessionStorage.setItem(SESSION_KEY, data.session_id); return data.session_id; })
    .catch(() => null)
    .finally(() => { opening = null; });
  return opening;
}

export function clearCreationSession() {
  try { sessionStorage.removeItem(SESSION_KEY); } catch {}
}
